export class messageParser {
    constructor() {
        this.deliveryServices = [
            "ອານຸສິດ", "ອະນຸສິດ", "ອານຸສີດ", "ອະນຸສີດ",
            "ຮຸ່ງອາລຸນ", "ຮຸ່ງອາລຸ່ນ", "ຮຸງອາລຸນ",
            "ມີໄຊ"
        ];
        this.deliveryServiceMapping = {
            "ອານຸສິດ": "ANOUSITH",
            "ອະນຸສິດ": "ANOUSITH", 
            "ອານຸສີດ": "ANOUSITH",
            "ອະນຸສີດ": "ANOUSITH",
            "ຮຸ່ງອາລຸນ": "HAL",
            "ຮຸ່ງອາລຸ່ນ": "HAL",
            "ຮຸງອາລຸນ": "HAL",
            "ມີໄຊ": "MX",
            "ມິໄຊ": "MX",
        };
        this.markers = {
            branch: [{ marker: "ສາຂາ", type: "prefix" }],
            village: [
                { marker: "ບ້ານ", type: "prefix" },
                { marker: "ບ ", type: "prefix" }
            ],
            district: [
                { marker: "ເມືອງ", type: "prefix" },
                { marker: "ມ ", type: "prefix" }
            ],
            province: [
                { marker: "ແຂວງ", type: "prefix" },
                { marker: "ຂ ", type: "prefix" }
            ]
        };
    }

    /**
     * Parse delivery service from message text
     * @param {string} message - The message text to parse
     * @returns {Object} - Object containing delivery_service code or null
     */
    parseDeliveryService(message) {
        if (!message || typeof message !== 'string') {
            return { delivery_service: null };
        }

        // Clean the message (remove extra spaces, normalize)
        const cleanMessage = message.trim();

        // Check each delivery service name in the mapping
        for (const [serviceName, serviceCode] of Object.entries(this.deliveryServiceMapping)) {
            if (cleanMessage.includes(serviceName)) {
                return { delivery_service: serviceCode };
            }
        }

        // If no delivery service found, return null
        return { delivery_service: null };
    }
}